"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Settings_1 = __importDefault(require("configs/Settings"));
const userInfoEndpointKeys_1 = require("./userInfoEndpointKeys");
const request_1 = __importDefault(require("@hotmart/request"));
request_1.default.register(`${Settings_1.default.api.userprofile}`, {
    get: {
        [userInfoEndpointKeys_1.UserInfoEndpointKeys.GetUserProfile]: '/user?onlySupportedLocales=true'
    }
});
request_1.default.register(`${Settings_1.default.api.businessWorkspace}`, {
    get: {
        [userInfoEndpointKeys_1.UserInfoEndpointKeys.GetUserTypeInfo]: '/user/type-info'
    }
});
